import { motion } from 'framer-motion';
import { ReactNode } from 'react';
import { toSeconds, useMotion } from './motion-provider';

interface FadeInProps {
  children: ReactNode;
  /** Offset for hand-sequenced siblings; prefer `StaggerList` for groups. */
  delayMs?: number;
  testId?: string;
}

const RISE_PX = 4;

/** Fade (and a small rise) for content that appears after a load. */
export const FadeIn = ({
  children,
  delayMs = 0,
  testId,
}: FadeInProps): JSX.Element => {
  const { durations, prefersReducedMotion } = useMotion();
  const rise = prefersReducedMotion ? 0 : RISE_PX;

  return (
    <motion.div
      data-testid={testId}
      data-reduced-motion={prefersReducedMotion}
      initial={{ opacity: 0, y: rise }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: toSeconds(durations.short),
        delay: toSeconds(delayMs),
        ease: 'easeOut',
      }}
    >
      {children}
    </motion.div>
  );
};
